/**
 * @file tabs-body.component.tsx
 * @description Компонент табового тела формы объекта для Task Manager приложения, который обеспечивает отображение формы с множественными вкладками для группировки полей по функциональности. Динамически рендерит вкладки на основе конфигурации tabs, интегрируется с react-hook-form для управления состоянием, поддерживает навигацию между вкладками, отображение информации об авторе и датах, включает индикатор загрузки и обработку ошибок с привязкой к конкретным вкладкам.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['moment', '@components/ui/base/tabs', '@components/ui/indicators/loader', '@components/ui/base/text', 'react']
 * @related-files ['src/features/object-form/object-form.component.tsx', 'src/features/object-form/components/simple-body.component.tsx']
 */

import moment from 'moment';
import { Tabs } from '@components/ui/base/tabs';
import { Loader } from '@components/ui/indicators/loader';
import { Text } from '@components/ui/base/text';
import { createElement } from 'react';
import { FullForm } from '@src/types/form-props';
import { tabObject } from '@src/types';

/**
 * Props для компонента TabsBody
 */
interface ITabsBodyProps extends FullForm {
    /** Массив объектов вкладок для отображения */
    tabs: tabObject[];
    /** Компонент формы для отображения в правой панели */
    form: React.ComponentType<FullForm>;
}

export const TabsBody = ({
    tabs,
    item,
    control,
    setValue,
    getValues,
    form,
    errorListRef,
    setError,
    formErrors,
    clearErrors,
    watch
}: ITabsBodyProps) => {
    return (
        <div className="objectForm__content flex-1 h-full relative">
            <div className="flex flex-col gap-default h-full w-full flex-1">
                <Tabs
                    items={tabs}
                    control={control}
                    data={item}
                    setValue={setValue}
                    getValues={getValues}
                    setError={setError}
                    formErrors={formErrors}
                    watch={watch}
                    clearErrors={clearErrors}
                    errorListRef={errorListRef}
                />

                <div className="objectForm__footer pt-[2.1171vmin] pb-[1.0585vmin] pr-[33.2382vmin]">
                    {item?.$createdAt && (
                        <Text size="m" view="ghost">
                            {`Создан ${item.$createdBy} ${moment(item.$createdAt)
                                .local()
                                .format('DD.MM.YYYY в HH:mm')}`}
                        </Text>
                    )}
                </div>
            </div>

            <div className="objectForm__right-block bg-[#F1F5F6] border-solid border-l-[0.1059vmin] border-[#B2C4D0] absolute right-0 top-0 bottom-0 w-[33.2382vmin] p-[1.0585vmin_1.482vmin] mt-[4.2667vmin] gap-[1.0585vmin] flex flex-col">
                {item ? (
                    createElement(form, {
                        control,
                        item,
                        setValue,
                        getValues,
                        errorListRef,
                        watch,
                        setError,
                        formErrors,
                        clearErrors
                    })
                ) : (
                    <Loader />
                )}
            </div>
        </div>
    );
};
